import { client } from './client';

// --- User profile ---

export const updateUser = async (data) => {
    const response = await client.put('/v1/user', data);
    return response.data;
};

export const deleteUser = async (password) => {
    await client.delete('/v1/user', {
        data: { password },
    });
};
